import { styled } from 'stitches.config'

export const BenefitsRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  paddingBottom: '16px',
  paddingTop: '40px',
  position: 'relative',
  overflow: 'hidden',
  '@bp2': {
    paddingBottom: '140px',
  },
})

export const BenefitsContainer = styled('div', {
  padding: 0,
  width: '100%',
  position: 'relative',
  margin: 'auto',
  zIndex: 1,

  '@bp2': {
    maxWidth: '1500px',
    padding: '0px 24px',
  },
})

export const BenefitsSection = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 0,
  position: 'relative',
  flexDirection: 'column-reverse',
  gap: 0,

  '@bp2': {
    gap: '48px',
    flexDirection: 'row',
    marginBottom: '-90px',
  },
})

export const TextWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '300px',
  margin: 0,
  marginTop: '24px',
  marginBottom: '16px',
  order: 1,
  '@bp2': {
    maxWidth: 'none',
    marginTop: '0',
    order: 0,
    marginBottom: 0,
  },
  variants: {
    type: {
      safety: {
        '@bp2': {
          marginBottom: '170px',
          width: '450px',
        },
      },
      convenience: {
        '@bp2': {
          width: '380px',
          marginRight: '120px',
          marginTop: '60px',
        },
      },
      quality: {
        '@bp2': {
          width: '380px',
        },
      },
      result: {
        '@bp2': {
          width: '380px',
          marginRight: '120px',
          marginTop: '60px',
        },
      },
    },
  },
})

export const ImageWrapper = styled('div', {
  width: '100%',
  maxWidth: '400px',
  order: 2,
  '@bp2': {
    maxWidth: 'none',
    width: '800px',
    order: 0,
  },

  variants: {
    zIndex: {
      '1': {
        zIndex: '1',
      },
      '2': {
        zIndex: '2',
      },
      '3': {
        zIndex: '3',
      },
    },
  },
})

export const IconWrapper = styled('div', {
  zIndex: '4',
  position: 'absolute',
  display: 'none',
  variants: {
    type: {
      badge: {
        bottom: '40px',
        width: '140px',
        left: '20px',
      },
      meat: {
        bottom: '-30px',
        left: '340px',
        width: '260px',
      },
      heart: {
        top: '90px',
        right: '-50px',
        width: '170px',
      },
      dog: {
        bottom: '-90px',
        right: '200px',
        width: '320px',
      },
    },
  },
  '@bp2': { display: 'block' },
})

export const Blob1Wrapper = styled('div', {
  position: 'absolute',
  display: 'none',
  '@bp2': { display: 'block' },
  top: '0px',
  right: '0px',
  overflow: 'hidden',
  zIndex: '0',
  width: '400px',
})

export const Blob2Wrapper = styled('div', {
  position: 'absolute',
  display: 'none',
  '@bp2': { display: 'block' },
  top: '290px',
  left: '-40px',
  zIndex: '0',
  width: '300px',
})

export const Blob3Wrapper = styled('div', {
  position: 'absolute',
  display: 'none',
  '@bp2': { display: 'block' },
  bottom: '0px',
  right: '0px',
  zIndex: '0',
  width: '500px',
})

export const Blob4Wrapper = styled('div', {
  position: 'absolute',
  display: 'none',
  '@bp2': { display: 'block' },
  bottom: '-6px',
  left: '0px',
  right: '182px',
  margin: 'auto',
  zIndex: '0',
  width: '500px',
})

export const SectionTitle = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  marginBottom: '$6',
  zIndex: '0',
})
